// extracted by mini-css-extract-plugin
export default {"welcomeBannerContainer":"WelcomeBanner_welcomeBannerContainer__WhNaO"};